import { TrendingMedia, DownloadPageLayout } from '@bpm-web-app/components';
import { AnonymousUserBanner } from '@bpm-web-app/components/src/lib/shared';

export default function Trending({ title }: { title: string }) {
    return (
        <DownloadPageLayout title={title}>
            <AnonymousUserBanner addTopPadding centerAlignOnMobile />
            <TrendingMedia />
        </DownloadPageLayout>
    );
}

export async function getStaticProps() {
    return {
        props: {
            title: 'Trending',
        },
    };
}
